// @flow
import * as R from 'ramda';

export const hasError = (errorCode: string, graphQLErrors: any = []) => R.any(R.propEq('code', errorCode), graphQLErrors);

export const getError = (errorCode: string, graphQLErrors: any = []) => R.find(R.propEq('code', errorCode), graphQLErrors);
